import React, { useEffect, useState } from 'react';
import Button from '../../../ui/Button/Button';
import Dialog from '../../../ui/Dialog/Dialog';
import Icon from '../../../ui/Icon';
import { ICONS } from '../../../ui/icon-map';
import LoadingSpinner from '../../../components/LoadingSpinner';
import { finesService, errorMessage } from '../../../services/finesService';
import { openReceipt, paidOn, payerText, howPaid } from './rtaPayments';

// The proof window (owner, 16 Oct 2026: "شباك جوه يلو فيه صفحة الإيصال اللي فيها المخالفة بس وسطرها متظلل"): the RTA
// receipt page that holds the fine - a batch receipt runs to 9 pages - with its row highlighted by the engine
// (api/rta_payments.receipt_page); the whole PDF only on request. `receipt` = {ref, ticket, at, p} from the Proof column
// or the fine window (an impound: no ticket, its offence minute `at`).
export default function ReceiptPageModal({ receipt, onClose }) {
    const { ref, ticket = '', at = '', p } = receipt;
    const [page, setPage] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        let alive = true;
        setPage(null);
        setError(null);
        finesService.rtaReceiptPage(ref, { ticket, at })
            .then((r) => { if (alive) setPage(r); })
            .catch((e) => { if (alive) setError(e?.response?.status === 404 ? `No PDF is kept for receipt ${ref}` : errorMessage(e)); });
        return () => { alive = false; };
    }, [ref, ticket, at]);

    const who = [p ? payerText(p) : '', p ? paidOn(p.paid_at) : '', p ? howPaid(p) : ''].filter(Boolean).join(' · ');
    return (
        <Dialog open onClose={onClose} size="lg" title={<span className="font-mono">Receipt {ref}</span>}>
            {who && <div className="mb-2 text-center text-sm font-medium text-gray-900">{who}</div>}
            {error ? (
                <div role="alert" className="rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700 text-center">{error}</div>
            ) : !page ? <LoadingSpinner message="Reading the receipt…" /> : (
                <>
                    <div className="mb-2 text-center text-sm text-gray-700">
                        {page.found ? `Page ${page.page} of ${page.pages} - the ${ticket ? "fine's" : "impound's"} line is highlighted`
                            : `The ${ticket ? "fine's" : "impound's"} line was not found on the receipt - page ${page.page} of ${page.pages}`}
                    </div>
                    <img src={`data:image/png;base64,${page.png}`} alt={`Receipt ${ref}, page ${page.page} of ${page.pages}`}
                         className="mx-auto w-full max-w-[820px] rounded border border-gray-300" />
                </>
            )}
            <div className="mt-3 flex justify-center">
                <Button size="sm" variant="secondary" leadingIcon={<Icon glyph={ICONS.document} size="sm" />} onClick={() => openReceipt(ref)}>
                    Full receipt (PDF)
                </Button>
            </div>
        </Dialog>
    );
}
